import React from "react";
import "./Typhography.scss";

export interface TypographyProps {
  /** The variant to use.
   * @default "body1"
   */
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "body1" | "body2" | "link1" | "link2" | "price1" | "price1-symbol" | "price2" | "price2-symbol";
  /**
   * The content of the component.
   */
  children?: React.ReactNode;
  /**
   * Override or extend the styles applied to the component.
   */
  style?: React.CSSProperties;
  onClick?: () => void;
  className?: string;
  dangerouslySetInnerHTML?: { __html: string };
}

export default function Typography({ variant = "body1", children, style, onClick, className, dangerouslySetInnerHTML }: TypographyProps) {
  switch (variant) {
    case "h1":
      return (
        <h1 className={`typography-h1 ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </h1>
      );
    case "h2":
      return (
        <h2 className={`typography-h2 ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </h2>
      );
    case "h3":
      return (
        <h3 className={`typography-h3 ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </h3>
      );
    case "h4":
      return (
        <h4 className={`typography-h4 ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </h4>
      );
    case "h5":
      return (
        <h5 className={`typography-h5 ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </h5>
      );
    case "h6":
      return (
        <h6 className={`typography-h6 ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </h6>
      );
    case "body1":
    case "body2":
      return (
        <p className={`${variant} ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </p>
      );
    case "link1":
    case "link2":
      return (
        <a className={`${variant} ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </a>
      );
    case "price1":
      return (
        <span className={`price1 ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </span>
      );
    case "price2":
      return (
        <span className={`price2 ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </span>
      );
    case "price1-symbol":
      return (
        <span className={`price1-symbol ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </span>
      );
    case "price2-symbol":
      return (
        <span className={`price2-symbol ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </span>
      );
    default:
      return (
        <p className={`body1 ${className || ""}`} style={style} onClick={onClick} {...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}>
          {children}
        </p>
      );
  }
}
